/**
 * @file User entity.
 * @author Tom Verschoore de la Houssaije
 */
import { BreezeService } from '../../core/breeze.service';
/** User entity. */
var User = /** @class */ (function () {
    function User() {
        // WARNING: Do not define an id property. Use the PROPERTY_ID constant.
        /** Gets sets the user name (back end is pascal case) */
        this.Name = undefined;
        /** Gets sets the user language. */
        this.Language = undefined;
        /** Gets the OID of the attached Resource */
        this.Resource_Oid = undefined;
        /** Gets the attached Resource */
        this.resource = undefined;
        /** First name of the user */
        this.FirstName = undefined;
        /** Last name of the user */
        this.LastName = undefined;
        /** The HTML5 role for the user */
        this.HTML5Role = undefined;
        /** Gets the pictureUrl user. */
        this.pictureUrl = undefined;
    }
    Object.defineProperty(User.prototype, "fullName", {
        /**
         * Gets the full name of the user
         * @readonly
         * @type {string}
         */
        get: function () {
            if (this.FirstName && this.LastName) {
                return this.FirstName + " " + this.LastName;
            }
            return this.FirstName ? this.FirstName : this.LastName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "Resource", {
        /**
         * Gets the resource
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property
            if (!this.resource && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.resource;
        },
        /**
         * Sets the resource
         */
        set: function (value) {
            this.resource = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Disables/Deactivates the user
     * @returns {string} The label is displayed in an alert once the action is done
     */
    User.prototype.disable = function () {
        BreezeService.invokeMethod(this, 'Disable', []);
        return 'APP.DOMAIN.USER_DISABLED';
    };
    /**
     * Enables/Activates the user
     * @returns {string} A label is displayed in an alert once the action is done
     */
    User.prototype.enable = function () {
        BreezeService.invokeMethod(this, 'Enable', []);
        return 'APP.DOMAIN.USER_ENABLED';
    };
    return User;
}());
export { User };
